import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import SimulacaoModalForm from './simulacaomodal-form'
import AjuizamentoSimulacaoRepository from '@/shared/http/repositories/crm/ajuizamentoSimulacao.js'
import Tools from '@/components/tools/Tools.js'

// import AjuizamentoRepository from '@/shared/http/repositories/crm/ajuizamento.js'
// import AssuntoRepository from '@/shared/http/repositories/configurations/assunto.js'
// import ObjetoAcaoRepository from '@/shared/http/repositories/configurations/objetoacao.js'
// import ComarcaRepository from '@/shared/http/repositories/configurations/comarca.js'
// import PrognosticoRepository from '@/shared/http/repositories/configurations/prognostico.js'
// import FaseRepository from '@/shared/http/repositories/configurations/fase.js'
// import AdvogadoRepository from '@/shared/http/repositories/configurations/advogado.js'
// import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'

const ModalSimulacaoModel = {
  id: null,
  data: null,
  quantidadeParcelas: null,
  valorTotal: null,
  taxaJuros: null,
  valorParcela: null
}

export default {
  name: 'AjuizamentoModal',
  mixins: [ActionsForm],
  data () {
    return {
      data: ModalSimulacaoModel,
      form: SimulacaoModalForm,
      valorComJuros: 0
    }
  },
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    person: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async onLoad () {
      loading.push()
      this.onClear()
      this.$nextTick(() => {
        this.form.data.value = new Date().toISOString().split('T')[0]
      })
      loading.pop()
    },
    showModal () {
      this.$refs['modal-simulacao'].show()
    },
    hideModal () {
      this.onClear()
      this.$emit('Reload')
      this.$refs['modal-simulacao'].hide()
    },
    onCalculateValorParcela () {
      if (this.form.valorTotal.value === null) this.form.valorTotal.value = 0
      if (this.form.taxaJuros.value === null) this.form.taxaJuros.value = 0
      if (this.form.quantidadeParcelas.value === null) this.form.quantidadeParcelas.value = 1

      const juros = (this.form.taxaJuros.value / 100) + 1
      const valorParcela = this.form.valorTotal.value * juros / this.form.quantidadeParcelas.value

      this.form.valorParcela.value = valorParcela.toFixed(2)
      this.valorComJuros = (valorParcela * this.form.quantidadeParcelas.value).toFixed(2)
    },
    async onSave () {
      if (!Tools.ValidateForms(this.form, this.data, this, toast)) return

      loading.push()
      try {
        this.onCalculateValorParcela()
        this.data.pessoaId = this.person.id
        this.data.cardVinculadoId = this.card.id
        this.data.valorTotalComJuros = this.valorComJuros
        const response = await AjuizamentoSimulacaoRepository.Create(this.data)
        if (response.status === 200) {
          this.hideModal()
          toast.success(this.$lang.Common.Alerts.Success)
        }
      } catch (error) {
        console.log(error)
      } finally {
        loading.pop()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/simulacao/modal/simulacaomodal.js